import * as React from 'react'

import { Tag, TagColor } from '@factorialco/deprecated-design-system'

import { requisitionStatusLabel } from 'modules/ats/lib/utils/requisitionStatus'

interface Props {
  status: string
}

export const RequisitionStatusTag = ({ status }: Props) => {
  const statusTypeToColor: Record<string, TagColor> = {
    pending: TagColor.champagne,
    approved: TagColor.lime,
    cancelled: TagColor.grey,
    rejected: TagColor.radical,
  }
  return (
    <Tag leftItem="circle" inline showCircle type={statusTypeToColor[status] || TagColor.grey}>
      {requisitionStatusLabel(status)}
    </Tag>
  )
}
